import {Component, output, OutputEmitterRef} from '@angular/core';
import {TranslatePipe} from "@ngx-translate/core";
import {RouterLink, RouterLinkActive} from "@angular/router";

@Component({
  selector: 'app-info-menu',
  imports: [
    TranslatePipe,
    RouterLink,
    RouterLinkActive
  ],
  templateUrl: './info-menu.component.html',
  styleUrl: './info-menu.component.scss'
})
export class InfoMenuComponent {
  public routerLinkActivated: OutputEmitterRef<void> = output<void>();

  protected infoMenu: ({ label: string; link: string })[] = [
    {
      label: 'legalNotice.link',
      link: '/legalNotice/corporate-information',
    },
    {
      label: 'legalNotice.dataPrivacy.link',
      link: '/legalNotice/data-privacy',
    },
    {
      label: 'legalNotice.copyrightAndTrademarks.link',
      link: '/legalNotice/corporate-trademarks',
    },
    {
      label: 'legalNotice.dataPrivacyPage.link',
      link: '/legalNotice/privacy-settings',
    },
  ];
}
